import { useMemo } from "react";

/** Deterministic floating particles drifting slowly upward.
 * CSS-only, GPU-accelerated, no libs. Renders 24 particles by default. */
export default function FloatingParticles({ count = 24, color = "rgba(198,168,124,0.55)" }) {
  const particles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const seed = (i + 1) * 9973;
      const r = (n) => ((Math.sin(seed * n) + 1) / 2);
      const left = r(1) * 100;
      const size = 1 + r(2) * 2.5;
      const delay = r(3) * 12;
      const duration = 14 + r(4) * 12;
      const drift = (r(5) - 0.5) * 40;
      const opacity = 0.15 + r(6) * 0.5;
      return { left, size, delay, duration, drift, opacity, key: i };
    });
  }, [count]);

  return (
    <div aria-hidden className="absolute inset-0 pointer-events-none overflow-hidden">
      <style>{`
        @keyframes floatUp {
          0% { transform: translate3d(0, 110%, 0); opacity: 0; }
          10% { opacity: var(--o); }
          90% { opacity: var(--o); }
          100% { transform: translate3d(var(--dx), -20%, 0); opacity: 0; }
        }
      `}</style>
      {particles.map((p) => (
        <span
          key={p.key}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            bottom: 0,
            width: p.size,
            height: p.size,
            borderRadius: "50%",
            background: color,
            boxShadow: `0 0 ${p.size * 3}px ${color}`,
            animation: `floatUp ${p.duration}s linear ${p.delay}s infinite`,
            ["--dx"]: `${p.drift}px`,
            ["--o"]: p.opacity,
          }}
        />
      ))}
    </div>
  );
}
